import React from 'react'
import { Box } from '@material-ui/core'
import { Heading } from './Heading'
import { InfoWithDescription } from './InfoWithDescription'
import { NotKnown } from './NotKnown'

export const BankDetails = ({ bankDetails }) => {
    console.log({ bankDetails })
    const { bank, accountNo, ifsc } = bankDetails
    return (
        <Box p={2} pl={0} pt={2} pb={2}>
            <Heading heading={'Bank Details'} />
            <Box
                pb={2}
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    borderBottom: 'solid 1px #E5E7EB',
                }}
            >
                {!bankDetails && <NotKnown message={'Not Available'} />}
                <InfoWithDescription title={`Bank`} duration={bank || 'Not Available'} />
                {/* <InfoWithDescription title={`Name`} duration={"Pankaj Pandey"} /> */}
                <InfoWithDescription title={`Account Number`} duration={accountNo || 'Not Available'} />
                <InfoWithDescription title={`IFSC Code`} duration={ifsc || 'Not Available'} />
            </Box>
        </Box>
    )
}
